var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "max-width": "1280px",
      "width": "100%"
    }
  }, [_c('list-heading', {
    attrs: {
      "title": "".concat(_vm.title, " \uBAA9\uB85D")
    },
    model: {
      value: _vm.showsSearch,
      callback: function callback($$v) {
        _vm.showsSearch = $$v;
      },
      expression: "showsSearch"
    }
  }), _c('v-data-table', {
    staticClass: "my-4 v-sheet--outlined",
    attrs: {
      "items": _vm.items,
      "headers": _vm.headers,
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.duration",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('program-list-duration', {
          attrs: {
            "value": item
          }
        })];
      }
    }, {
      key: "item.applications",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('application-list', {
          attrs: {
            "program": item
          }
        })];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('v-row', [_c('program-view', {
          attrs: {
            "item": item
          },
          model: {
            value: _vm.programs,
            callback: function callback($$v) {
              _vm.programs = $$v;
            },
            expression: "programs"
          }
        }), _vm._v(" "), _c('v-btn', {
          attrs: {
            "small": "",
            "text": ""
          },
          on: {
            "click": function click($event) {
              return _vm.remove(item);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-delete")])], 1)], 1)];
      }
    }], null, true)
  }), _c('v-pagination', {
    staticClass: "my-4",
    attrs: {
      "length": _vm.pageCount,
      "total-visible": 11
    },
    on: {
      "input": function input(page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page: page
          })
        });
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  }), _c('program-view', {
    attrs: {
      "title": _vm.title,
      "category": _vm.category,
      "isNew": ""
    },
    on: {
      "input": function input($event) {
        _vm.totalCount += 1;
      }
    },
    model: {
      value: _vm.programs,
      callback: function callback($$v) {
        _vm.programs = $$v;
      },
      expression: "programs"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }